import { combineReducers } from 'redux';

import prosesshjelp from '@helsenorge/core-framework/prosesshjelp/store';
import { resourcesApi } from '@helsenorge/core-framework/resources';
import { additionalPageContentApi } from '@helsenorge/framework-utils/additional-page-content';
import { tjenesteTeksterApi } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { createLanguageReducer } from '@helsenorge/framework-utils/language';

import behandlingsvalgApi from './behandlingsvalgApi';
import breadcrumb from './reducers/breadcrumb';
import samvalgsverktoyApi from './samvalgsverktoyApi';

const rootReducer = combineReducers({
  // Felles
  language: createLanguageReducer(),
  prosesshjelp,
  [additionalPageContentApi.reducerPath]: additionalPageContentApi.reducer,
  [tjenesteTeksterApi.reducerPath]: tjenesteTeksterApi.reducer,
  [resourcesApi.reducerPath]: resourcesApi.reducer,
  // Spesifikt for Samvalg
  [samvalgsverktoyApi.reducerPath]: samvalgsverktoyApi.reducer,
  [behandlingsvalgApi.reducerPath]: behandlingsvalgApi.reducer,
  breadcrumb,
});

export default rootReducer;
